import Dropzone from 'dropzone'

/**
 * need to use Dropzone so it doesn't get tree-shaken out
 * Dropzone automatically registers itself as a jQuery plugin, so we can call .dropzone on any jquery element after importing it
 */
Dropzone

$(document).on('turbo:load turbo:render', () => {

    let dropzoneOptions = {
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
            "Accept": "application/javascript"
        },
        success: function(file, response) {
            (0, eval)(response);
        },
        queuecomplete: function(file, response) {
            $('.dz-processing.dz-complete').remove();
        },
        dragleave: function(e) {
        },
        createImageThumbnails: false,
        maxFilesize: 32,
        dictFileTooBig: 'The file you are attempting to upload exceeds the max file size limit.',
        acceptedFiles: 'application/pdf,.doc,.docx,.csv,.png,.jpg,.jpeg',
        dictInvalidFileType: 'This file type is not supported.',

        previewTemplate: `

            <div class="dz-preview dz-file-preview">
            
              <div class="dz-controllers">
                 <div class="dz-error-mark">
                  <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
                    <title>Error</title>
                    <defs></defs>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                      <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">
                        <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            
              <div class="dz-details">
                <div class="dz-size"><span data-dz-size></span></div>
                <div class="dz-filename"><span data-dz-name></span></div>
              </div>
              <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
              <div class="dz-error-message">
                <p data-dz-errormessage></p>
              </div>
            </div> `

    };

    (<any>$(".dropzone")).dropzone(dropzoneOptions);

    const $body = $('body');
    $body.on('dragenter dragover', ':not(.dropzone)', (e) => {
        e.preventDefault();
        $('div.dropzone').addClass('dz-drag-hover');
    });

    $body.on('dragleave', (e) => {
        //@ts-ignore
        if (e.relatedTarget == null) {
            $('div.dropzone').removeClass('dz-drag-hover');
        }
    });

    $body.on('drop', (e) => {
        e.preventDefault();
        $('div.dropzone').removeClass('dz-drag-hover');
    });

});


const $doc = $(document);

$doc.on('click',  '.dz-error-mark', (e) => {
    $(e.target).closest('.dz-preview').remove();
});